<script>
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import { all_users_store, user_store, api_host } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { state_codes, show_alert } from '../../globals.js';
    import { formatDate, formatPhoneNumber, handle_not_subscribed } from '../../utils/format.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();
    let LIVE_USERS = [], all_users = [];
    $: TOTAL_ITEMS = LIVE_USERS.length;
    let is_busy = false;
    let prev_filter = undefined;
    let page_filter = "all";
    let is_mounted = false;
    let content_title = "";
    let date_range_obj = undefined;
    let myself = {};

    let set_date_range_obj = (obj) => {
        date_range_obj = obj;
    }

    user_store.subscribe(value => {
        myself = value;
    });

    function process_params(qs) {
        setTimeout(()=>{ window.scrollTo(0, 0); }, 100);
        const params = new URLSearchParams(qs);
        console.log('filter', params.get('filter'));
        if(params.has('filter')){
            page_filter = params.get('filter');
            if (page_filter === "all") {
                LIVE_USERS = all_users;
            } else if (page_filter === "all_crew") {
                LIVE_USERS = all_users.filter((e) => {
                    return e.role.toLowerCase() === 'contractor' || e.role.toLowerCase() === 'employee';
                });
            } else if (page_filter === 'inactive') {
                LIVE_USERS = all_users.filter((e) => {
                    return !e.is_active;
                });
            } else {
                const PAGE_MATCH = page_filter.toLowerCase();
                LIVE_USERS = all_users.filter((e) => {
                    return PAGE_MATCH.includes(e.role.toLowerCase()) ;
                });
            }
            if (myself.plan_type === 'basic') {
                LIVE_USERS = LIVE_USERS.filter((e) => { return e.role.toLowerCase() !== 'client'; });
            }

            if (page_filter === "employees" || page_filter === "contractors" || page_filter === "all_crew") {
                content_title = page_filter.replaceAll('_', ' ');
            } else {
                content_title = page_filter.replaceAll('_', ' ');
            }
        }

        if (prev_filter && prev_filter !== page_filter) {
            if (date_range_obj) { date_range_obj.clear(); }
        }
        prev_filter = page_filter;
    }
    $: if($querystring !== undefined) {
        process_params($querystring);
    }

    const get_user_active_style = (is_active, role) => {
        if (role === 'applicant') {
            return 'display: none;';
        }
        if (is_active) {
            return 'width: 12px;height: 12px;border-radius: 50%;margin-left: 5px;background: green;';
        } else {
            return 'width: 12px;height: 12px;border-radius: 50%;margin-left: 5px;background: red;';
        }
    }
    all_users_store.subscribe(all_users_value => {
        all_users = [];
        for (let i = 0; i < all_users_value.length; i ++) {
            const user = all_users_value[i];
            // if (myself.role === 'landscaper' || user.role !== 'landscaper') {
            all_users.push({
                "id": user.id,
                "user_id": user.user_id,
                "n": `<a sortValue='${user.first_name} ${user.last_name}' href='/#/User_Review?uid=${user.id}' style='display: flex;align-items: center;'>
                    ${user.first_name} ${user.last_name}
                    <div style='${get_user_active_style(user.is_active, user.role)}'></div>
                </a>`,
                'role': user.role === 'landscaper' ? 'owner' : user.role,
                "k": `<span style='text-transform: capitalize;'>${user.role === 'landscaper' ? 'Owner' : user.role}</span>`,
                "a": user.address + (user.address ? ', ' : '') + user.city + (user.city ? ', ' : '') + (user.state.length > 2 ? state_codes[user.state] : user.state),
                "mp": formatPhoneNumber(user.mobile_phone),
                "hp": formatPhoneNumber(user.home_phone),
                "em": user.email.includes('houseofyards.tmp') ? '' : user.email,
                "ca": formatDate(user.created_at),
                'not_allowed': user.role === 'landscaper' || user.job_count > 0 || user.connector_count > 0,
                'is_active': user.is_active,
                "ac": user.additional_comments,
                "ic": user.internal_comments,
            });
        }
        all_users.sort((a, b) => {
            if (a.n.toLowerCase() < b.n.toLowerCase()) return -1;
            if (a.n.toLowerCase() > b.n.toLowerCase()) return 1;
            return 0;
        });
        process_params($querystring);
    });

    onMount(async () => {
        setTimeout(()=>{is_mounted = true;}, 250);
    });

    let table_header_config = [
        {'t': 'User ID', 'fm': 'user_id', 'a': true},
        {'t': 'Name', 'fm': 'n', 'a': true},
        {'t': 'Type', 'fm': 'k', 'a': true},
        {'t': 'Address', 'fm': 'a', 'a': true},
        {'t': 'Mobile Phone', 'fm': 'mp', 'a': false},
        {'t': 'Home Phone', 'fm': 'hp', 'a': false},
        {'t': 'Email', 'fm': 'em', 'a': true},
        {'t': 'Created On', 'fm': 'ca', 'a': true},
        {'t': 'Additional Comments', 'fm': 'ac', 'a': false},
        {'t': 'Internal Comments', 'fm': 'ic', 'a': false}
    ];

    let action_items = [
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {
            Swal.fire({
                title: "Delete this user?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                if (e.isConfirmed) {
                    const res = await doFetch(
                        `${api_host}/api/delete/manager`,
                        'POST',
                        { uid: id },
                        { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        init_data('users');
                    } else {
                        toast_message(false, res.msg || 'Bad request', 2000);
                    }
                }
            });
        }},
    ];
    $: action_items_acc_role = (myself.role === 'landscaper' || myself.role === 'admin') ? action_items : undefined;
    $: hide_remove_column = (!(LIVE_USERS.filter(user => user.role === 'admin' || user.role === 'manager').length || ['vendors', 'applicants', 'clients', 'all_crew', 'contractors', 'employees'].includes(page_filter)) ? true : false);
    
    let field_formats = {
        "c": (p) => {
            if(typeof(p) === "string" && !p.startsWith("$")){
                var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
                return formatter.format(parseFloat(p));
            }else{
                return p;
            }
        },
        "ac": (ac) => {
            return ac && ac.length > 15 ? `${ac.substring(0, 15)}...` : ac;
        },
        "ic": (ic) => {
            return ic && ic.length > 15 ? `${ic.substring(0, 15)}...` : ic;
        },
    };

    let onclick_action = {
        'ac': (v) => show_alert('Additional Comments', v),
        'ic': (v) => show_alert('Internal Comments', v),
    };

    let field_styles = {
        "c": "text-align: right;"
    }

    let sort_functions = {
        // "c": (el1, el2) => {return parseFloat(el1) - parseFloat(el2)},
        "ca": (el1, el2) => {
            let dateA = new Date(el1.split(' - ')[0]);
            let dateB = new Date(el2.split(' - ')[0]);
            if (dateA < dateB) { return -1; }
            if (dateA > dateB) { return 1; }
            return 0;
        }
    }

    let date_value = '';
    
    const createNewUser = () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        push(`#/User_Create?user_type=${page_filter}`);
    };
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    {#if is_mounted}
        <div class="jobtableholder">
            <ResponsiveTable
                table_data={LIVE_USERS} 
                field_formats={field_formats} 
                field_styles={field_styles} 
                sort_functions={sort_functions} 
                onclick_action={onclick_action}
                num_per_page={100}
                date_filter_param='ca'
                show_date_range={true}
                action_items_title='Remove'
                refresh_action='users'
                bind:is_busy={is_busy}
                bind:set_date_range_obj={set_date_range_obj}
                bind:table_header_config={table_header_config}
                bind:total_items={TOTAL_ITEMS}
                bind:action_items={action_items_acc_role}
                bind:hide_remove_column={hide_remove_column}
                bind:date_value={date_value}
            />
        </div>
    {/if}

    <div class="buttonholder">
        <button on:click={() => {createNewUser();}}><i class="far fa-user-plus"></i> New User</button>
    </div>    
</div>

<style>
    .contentholder {
        padding: 0px;
    }

    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
    }
    .buttonholder button {
        max-width: 300px;
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        width: 250px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            width: 100%;
        }
    }
</style>